import * as React from "react";
import { useLogsBrowserService } from "./logsBrowser";
import { BrowserServiceModal } from "../../identity/create/browserServiceModal";
import { LogsBrowserCloudAccountModal } from "./logsCloudaccountModal";
import { request } from "../../../services/cpln";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { formSetValue, formTriggerValidation } from "../../gvc/testNewForm/utils";
import { parseLink } from "../../../utils/linkParser/linkParser";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";
import { Button, Space } from "antd";
import { Tooltip } from "../../../components/Tooltip";
import { EllipsisOutlined } from "@ant-design/icons";

interface Props {
  index: number;
}
export const S3: React.FC<Props> = ({ index }) => {
  const { id: formId } = useCpFormContext();

  const lbs = useLogsBrowserService();

  return (
    <>
      <div style={{ maxWidth: 1000 }}>
        <CpFormItem>
          <CpLabel name={`logging.${index}.s3.bucket`}>Bucket</CpLabel>
          <Space.Compact>
            <CpInput name={`logging.${index}.s3.bucket`} style={{ maxWidth: 600 }} />
            <Tooltip title={`Browse Buckets`}>
              <Button icon={<EllipsisOutlined />} onClick={() => lbs.setPage("cloudaccount")} />
            </Tooltip>
          </Space.Compact>
          <CpErrorWarning name={`logging.${index}.s3.bucket`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.s3.credentials`}>Credentials</CpLabel>
          <CpDescription>Select an AWS secret to access S3</CpDescription>
          <CpKindSelect
            kind="secret"
            queries={[{ property: "type", value: "aws" }]}
            name={`logging.${index}.s3.credentials`}
            optionValue="name"
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name={`logging.${index}.s3.credentials`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.s3.region`}>Region</CpLabel>
          <CpInput name={`logging.${index}.s3.region`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`logging.${index}.s3.region`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`logging.${index}.s3.prefix`}>Prefix</CpLabel>
          <CpInput name={`logging.${index}.s3.prefix`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`logging.${index}.s3.prefix`} />
        </CpFormItem>
      </div>
      {lbs.page === "cloudaccount" && <LogsBrowserCloudAccountModal lbs={lbs} />}
      <BrowserServiceModal
        open={lbs.page === "bucket"}
        title={`Select S3 Bucket`}
        cloudaccountLink={
          lbs.cloudAccountName ? parseLink(lbs.cloudAccountName, { kind: "cloudaccount" }).absolute : ""
        }
        restrictToBucket={true}
        onClose={async (uri) => {
          if (uri.length < 1) {
            lbs.setPage("none");
            lbs.setCloudAccountName("");
            return;
          }
          const bucket = uri[0];
          const bucketName = bucket._cpln.label;
          formSetValue(formId, `logging.${index}.s3.bucket`, bucketName);
          const locationUrl = `${bucket._cpln.href}/-aspect/location`;
          const { data } = await request({ service: "browser", url: locationUrl });
          if (data?.data) {
            if (data.data.length > 0) {
              const _region = data.data[0];
              formSetValue(formId, `logging.${index}.s3.region`, _region);
            }
          }

          formTriggerValidation(formId);

          lbs.setPage("none");
          lbs.setCloudAccountName("");
        }}
        selectionType={"single"}
      />
    </>
  );
};
